'use strict';

angular.module('ClinicApp').factory('QuestionService', function($q, $http, ClinicConfig, QuestionResource) {
  return {
    listClinicQuestions: function() {
      return $http.get(`${ClinicConfig.HOSTNAME}/question`, {
        params: {
          modelType: 'Clinic',
        },
      }).then(function(response) {
        return response.data;
      });
    },

    listDoctorQuestions: function() {
      return $http.get(ClinicConfig.HOSTNAME + '/question', {
        params: {
          modelType: 'Doctor',
        },
      }).then(function(response) {
        return response.data;
      });
    },

    respond: function(questionId, modelType, modelId, response) {
      if (!modelType || !modelId) {
        return $q.reject('QuestionService.respond: modelType and modelId are required.');
      }
      var params = {
        modelType: modelType,
        modelId: modelId,
      };
      if (response) {
        params.response = response;
      }
      return QuestionResource.save({
        id: questionId,
        action: 'respond',
      }, params).$promise;
    },
  };
});
